import { connect } from 'react-redux';
import { getCountriesList } from '../../store/countries/selectors';
import { CountriesList } from './CountriesList';

const mapStateToProps = (state) => ({
  countries: getCountriesList(state),
});

export default connect(mapStateToProps)(CountriesList);
